<span>{{ 'AITopic::TopicTrainingReadyMessage' | abpLocalization }}</span>
